export const INITIAL_DEFAULT_PAGE_MODEL = {
    backgroundUrl: '',
    backgroundFixed: false,
    showTitle: true,
    titleSize: '24px',
    titleBold: false,
    showSubtitle: true,
    subtitleSize: '16px',
    subtitleBold: false,
    headerAlign: 'flex-start',
    titleRu: 'Заголовок',
    titleEn: 'Title',
};
